import { createAction } from '../utils';
import { SuggestType } from './types';
export var setSuggest = createAction(SuggestType.SET);
